(function () {
  function labelBooqableCloseButtons() {
    const buttons = document.querySelectorAll('button.bq-close, button.bq-branded.bq-close');

    buttons.forEach((btn) => {
      const hasLabel =
        btn.getAttribute('aria-label') ||
        btn.getAttribute('title') ||
        (btn.textContent && btn.textContent.trim().length > 0);

      if (!hasLabel) {
        btn.setAttribute('aria-label', 'Close reservation cart');
        btn.setAttribute('title', 'Close reservation cart');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    labelBooqableCloseButtons();

    const observer = new MutationObserver(() => {
      labelBooqableCloseButtons();
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  });
})();